var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { create } from 'zustand';
import { subscribeWithSelector } from 'zustand/middleware';
import { persistNSync } from 'persist-and-sync';
var defaultCall = {
    call: null,
    isMuted: false,
    isOnHold: false,
    memberInfo: null,
    agentInfo: null,
    localStream: null
};
var initialCallState = {
    calls: [],
    lastCallSkill: null,
    lastCallContactID: null,
    lastCallRequireDisposition: false,
    showAdditionalDirectory: false,
    isConferenceInitiated: false,
    isConferenceActive: false,
    hasActiveCall: false
};
export var useCallStore = create()(subscribeWithSelector(persistNSync(function (set) { return (__assign(__assign({}, initialCallState), { setCalls: function (_a) {
        var index = _a.index, fields = __rest(_a, ["index"]);
        return set(function (state) {
            var calls = __spreadArray([], state.calls, true);
            while (calls.length <= index) {
                calls.push(__assign({}, defaultCall));
            }
            calls[index] = __assign(__assign({}, calls[index]), Object.fromEntries(Object.entries(fields).filter(function (_a) {
                var v = _a[1];
                return v !== undefined;
            })));
            return { calls: calls };
        });
    }, resetCalls: function () { return set({ calls: [], hasActiveCall: false }); }, removeCall: function (index) {
        return set(function (state) { return ({
            calls: state.calls.filter(function (_, i) { return i !== index; })
        }); });
    }, setLastCallSkill: function (skill) {
        return set({ lastCallSkill: skill });
    }, setLastCallContactID: function (contactID) {
        return set({ lastCallContactID: contactID });
    }, setLastCallRequireDisposition: function (requireDisposition) {
        return set({ lastCallRequireDisposition: requireDisposition });
    }, setShowAdditionalDirectory: function (show) {
        return set({ showAdditionalDirectory: show });
    }, setConferenceInitiated: function (value) {
        return set({ isConferenceInitiated: value });
    }, setConferenceActive: function (value) {
        return set({ isConferenceActive: value });
    }, setHasActiveCall: function (value) {
        return set({ hasActiveCall: value });
    } })); }, {
    name: 'nic-call-store',
    storage: 'localStorage',
    exclude: [/^set/, /^reset/, /^remove/, 'calls']
})));
export var selectCalls = function (state) { return state.calls; };
export var selectHasActiveCall = function (state) { return state.hasActiveCall; };
